import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProjectFilterInput } from "../../../api/psc";
import { DialogContext } from "../../../contexts/DialogueContext";
import { RootState } from "../../../slices/Store";
import {
    reloadProject,
    resetProjectFilter,
    setProjectsFilter,
} from "../slice/ProjectSlice";
import ProjectFilter from "./ProjectFilter";

export default function ProjectsFilter() {
    const dispatch = useDispatch();

    const projectState = useSelector((r: RootState) => r.projects);

    const { closeDialog } = useContext(DialogContext);

    const reload = () => {
        dispatch(reloadProject());
        closeDialog();
    };

    const handleFilterChange = (filter: ProjectFilterInput) => {
        dispatch(setProjectsFilter(filter));
    };

    const handleClearFilters = () => {
        dispatch(resetProjectFilter());
    };

    return (
        <ProjectFilter
            reloadCallback={reload}
            isLoading={projectState.isLoading}
            filter={projectState.filter}
            onFilterChange={handleFilterChange}
            hasAnyFilter={projectState.hasAnyFilter}
            clearFilters={handleClearFilters}
        />
    );
}
